import { isExperimentEnabled } from '@atlaskit/platform-feature-experiments/is-experiment-enabled';

import type { SnippetsPlugin } from '../snippetsPluginType';

import { getTemplateGalleryBlockMenuComponents } from './block-menu/getTemplateGalleryBlockMenuComponents';
import { getTemplateGalleryQuickInsertComponents } from './quick-insert/getTemplateGalleryQuickInsertComponents';

type Params = {
	api: Parameters<SnippetsPlugin>[0]['api'];
	onCreateSnippet?: Parameters<SnippetsPlugin>[0]['config']['onCreateSnippet'];
	openTemplateGallery?: () => void;
};

export const registerTemplateGalleryEntryPoints = ({
	api,
	onCreateSnippet,
	openTemplateGallery,
}: Params): void => {
	if (!openTemplateGallery && !onCreateSnippet) {
		return;
	}

	api?.blockMenu?.actions.registerBlockMenuComponents(
		getTemplateGalleryBlockMenuComponents({
			api,
			onCreateSnippet,
			onOpenTemplateGallery: openTemplateGallery,
		}),
	);

	if (openTemplateGallery && isExperimentEnabled('platform_editor_slash_command')) {
		api?.uiControlRegistry?.actions.register(
			getTemplateGalleryQuickInsertComponents({ api, onOpenTemplateGallery: openTemplateGallery }),
		);
	}
};
